export default __webpack_public_path__ + "assets/hero_1920.6a828482.webp";